// One SPA bundle, two public hosts: the landing renders on the site host, the
// console on every other host. REACT_APP_SITE_URL names the site host; unset
// (local dev, single-host stacks) keeps both halves on one host — landing at
// `/`, console under `/console`.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const origin = (url) => (url || '').trim().replace(/\/+$/, '');

/** Landing origin; empty when the split is off. */
export const SITE_URL = origin(process.env.REACT_APP_SITE_URL);

/** Console origin; the API host unless overridden. */
export const CONSOLE_URL = origin(process.env.REACT_APP_CONSOLE_URL || API_URL);

function hostOf(url) {
  try {
    return new URL(url).host.toLowerCase();
  } catch {
    return '';
  }
}

/** Split on and this page load is on the site host. */
export function isSiteHost() {
  return Boolean(SITE_URL) && window.location.host.toLowerCase() === hostOf(SITE_URL);
}

/** Split on and this page load is on the console host. */
export function isConsoleHost() {
  return Boolean(SITE_URL) && !isSiteHost();
}

/** Console path as a URL: absolute from the site host, relative otherwise. */
export function consoleUrl(path = '/') {
  return isSiteHost() ? `${CONSOLE_URL}${path}` : path;
}

/** Site path as a URL: absolute from the console host, relative otherwise. */
export function siteUrl(path = '/') {
  return isConsoleHost() ? `${SITE_URL}${path}` : path;
}

/** Native account flows live on the API host, including during SPA development. */
export function accountUrl(path) {
  const base = process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000');
  return `${origin(base)}${path}`;
}
